import { IInspectionTenantCategoriesHook } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

declare const abp: any;

export const useInspectionTenantCategories = (): IInspectionTenantCategoriesHook => {
  const { inspectionStore } = useStore();
  const { tenantCategories, tenantCategoriesLoading } = inspectionStore;

  useEffect(() => {
    inspectionStore.getAllCategoriesByTenantId(abp.session.tenantId);

    return () => inspectionStore.cleartenantCategories();
  }, [inspectionStore]);

  return {
    loading: tenantCategoriesLoading,
    dataSource: Array.from(tenantCategories.values()),
  };
};
